// extracted by mini-css-extract-plugin
export default {"section":"policy-page_section__U8fSX","title":"policy-page_title__tPij5"};